import React, { useState } from "react";
import { FiUpload } from "react-icons/fi";
import { baseUrl } from '../../shared';
import {
  Button,
  Select,
  MenuItem,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  LinearProgress,
} from "@mui/material";

export default function FirstTab({ foundAsset, onSuccess }) {
  const [files, setFiles] = useState([]); // [{ file, progress }]
  const [attachmentType, setAttachmentType] = useState("");
  const [open, setOpen] = useState(false); // modal
  const [uploading, setUploading] = useState(false);
  const [dragActive, setDragActive] = useState(false);

  // 📂 Add files from input or drop
  const addFiles = (selected) => {
    const newFiles = Array.from(selected).map((file) => ({
      file,
      progress: 0,
    }));
    setFiles((prev) => [...prev, ...newFiles]);
  };

  const handleFileChange = (e) => {
    if (e.target.files) addFiles(e.target.files);
  };

  const handleDrag = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === "dragenter" || e.type === "dragover") {
      setDragActive(true);
    } else if (e.type === "dragleave") {
      setDragActive(false);
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      addFiles(e.dataTransfer.files);
    }
  };

  // 🚀 Upload files in parallel with XHR
  const handleUpload = () => {
    if (files.length === 0 || !attachmentType) return;

    setOpen(true);
    setUploading(true);

    let completed = 0;
    files.forEach((f, idx) => {
      const formData = new FormData();
      formData.append("myFile", f.file);

      const xhr = new XMLHttpRequest();
      xhr.open("POST", baseUrl + "upload");

      xhr.setRequestHeader("username", localStorage.getItem("username"));
      xhr.setRequestHeader("bToken", localStorage.getItem("bToken"));
      xhr.setRequestHeader("catNo", foundAsset.catNo);
      xhr.setRequestHeader("attachmentType", attachmentType);

      // progress
      xhr.upload.onprogress = (e) => {
        if (e.lengthComputable) {
          const percent = Math.round((e.loaded * 100) / e.total);
          setFiles((prev) => {
            const updated = [...prev];
            updated[idx] = { ...updated[idx], progress: percent };
            return updated;
          });
        }
      };

      xhr.onload = () => {
        completed++;
        if (completed === files.length) {
          setOpen(false);
          onSuccess();
          setUploading(false);
          setFiles([]);
          setAttachmentType("");
        }
      };

      xhr.onerror = () => {
        console.error("Upload failed:", f.file.name);
        completed++;
        if (completed === files.length) {
          setOpen(false);
          setUploading(false);
        }
      };

      xhr.send(formData);
    });
  };

  return (
    <div>
      {/* Uploading Modal */}
      <Dialog open={open} onClose={() => !uploading && setOpen(false)}>
        <DialogTitle>Uploading Document</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {uploading ? "Uploading. Please wait…" : "Done"}
          </DialogContentText>
          {files.map((f, i) => (
            <div key={i} style={{ marginTop: "8px" }}>
              <div>{f.file.name}</div>
              <LinearProgress
                variant="determinate"
                value={f.progress}
                sx={{ height: 8, borderRadius: 5 }}
              />
            </div>
          ))}
        </DialogContent>
      </Dialog>

      {/* File Upload UI with drag & drop */}
      <form
        onSubmit={(e) => e.preventDefault()}
        className={`uploadBox ${dragActive ? "drag-active" : ""}`}
        onDragEnter={handleDrag}
        onDragOver={handleDrag}
        onDragLeave={handleDrag}
        onDrop={handleDrop}
      >
        {files.length > 0 ? (
          <ul>
            {files.map((f, i) => (
              <li key={i}>{f.file.name}</li>
            ))}
          </ul>
        ) : (
          <FiUpload className="upload-icon" />
        )}

        <div className="drag">
          Drop your files here or{" "}
          <label>
            <input
              type="file"
              multiple
              style={{ display: "none" }}
              onChange={handleFileChange}
            />
            <Button component="span" variant="outlined">
              Browse Files
            </Button>
          </label>
        </div>

        <p className="info">Supported: JPEG, PNG, PDF, HEIC</p>

        <Select
          value={attachmentType}
          onChange={(e) => setAttachmentType(e.target.value)}
          displayEmpty
        >
          <MenuItem value="">Select Upload Type</MenuItem>
          <MenuItem value="CERTIFICATE">1. Certificates</MenuItem>
          <MenuItem value="PARTS">2. Parts List</MenuItem>
          <MenuItem value="PHOTO">3. Photos</MenuItem>
        </Select>

        <Button
          variant="contained"
          onClick={handleUpload}
          disabled={uploading}
          sx={{ mt: 2 }}
        >
          Upload
        </Button>
      </form>
    </div>
  );
}
